import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../data/api";
import { connect } from "react-redux";
import {
  ADD_SALES_RETURNS_MODAL_LOADED,
  SALES_RETURN_SUBMITTED
} from "../../constants/actionTypes";

import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
// import Grid from '@material-ui/core/Grid';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DateFnsUtils from "@date-io/date-fns";
// import getTime from 'date-fns/getTime';
import format from "date-fns/format";
import {
  MuiPickersUtilsProvider,
  // KeyboardTimePicker,
  KeyboardDatePicker
} from "@material-ui/pickers";

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: "330px",
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    //   marginLeft: theme.spacing(1),
    //   marginRight: theme.spacing(1)
  },
  btnSubmit: {
    backgroundColor: "#1c3e5d",
    width: "100%",
    color: "#FFFFFF",
    minHeight: 50
  },
  dialogueActions: {
    display: "block",
    width: "100%",
    padding: "10px 24px 30px"
  },
  uploadButton: {
    textAlign: "center",
    backgroundColor: "#EEEEEE",
    width: "100%",
    margin: "16px 0 8px"
  },
  selectRoute: {
    maxWidth: "100%",
    "& label": {
      transform: "translate(14px, 13px) scale(1)"
    },
    "& div": {
      "& div": {
        padding: 10
      }
    }
  }
}));

const mapStateToProps = state => ({
  ...state.salesreturns
});

const mapDispatchToProps = dispatch => ({
  onLoad: mode => dispatch({ type: ADD_SALES_RETURNS_MODAL_LOADED, mode }),
  onSubmit: promise => {
    // console.log('payload:', promise);
    dispatch({ type: SALES_RETURN_SUBMITTED, payload: promise });
  }
});

function CreditNoteModal(props) {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  const classes = useStyles();
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(
    mm + "-" + dd + "-" + yyyy
  );

  const handleDateChange = date => {
    setSelectedDate(format(date, "dd-MM-yyyy"));
  };

  useEffect(() => {
    props.onLoad(props.mode);
  }, [props]);

  const onFileSelectedHandler = event => {
    //console.log(event.target.files[0]);
    setSelectedFile(event.target.files[0]);
  };
  const onSubmitClickHandler = () => ev => {
    ev.preventDefault();

    if (selectedDate && selectedFile) {
      let mTimeStamp = selectedDate;
      const invoice = {
        invoice_date: format(new Date(mTimeStamp), "dd-MM-yyyy"),
        invoice_file: selectedFile
      };
      // const promise = api.Invoices.create(invoice);
      // props.onSubmit(promise);

      //close modal
      props.handleClose();
    }
  };

  return (
    <Dialog
      open={props.opened}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
      className={classes.root}
    >
      <form
        className={classes.container}
        noValidate
        autoComplete="off"
        onSubmit={onSubmitClickHandler()}
      >
        <DialogTitle id="form-dialog-title">ENTER INVOICE DETAILS</DialogTitle>
        <DialogContent>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              // disableToolbar
              // variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Invoice date"
              value={selectedDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date"
              }}
              style={{ width: "100%" }}
            />
          </MuiPickersUtilsProvider>
          <input
            className={classes.uploadButton}
            // style={{ display: 'none' }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={onFileSelectedHandler}
          />
          {/* <label htmlFor="raised-button-file">
                      <Button variant="raised" component="span" className={classes.uploadButton}>
                          Select invoice file
                      </Button>
                  </label> */}
        </DialogContent>
        <DialogActions className={classes.dialogueActions}>
          <Button fullWidth className={classes.btnSubmit} type="submit">
            SUBMIT
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditNoteModal);
